const NoneCard = () => {
  return <div className="none-container" style={{}}></div>;
};
export default NoneCard;
